<template>
    <fieldset>
        <input v-for="(formField, key, index) in formFields" :key="index" type="hidden" :name="key" :value="formField">

        <input type="hidden" name="form_title" :value="formTitle">
        <input type="hidden" name="country" :value="country">
        <input type="hidden" name="written_language" :value="writtenLanguage">
        <input type="hidden" name="post_url_alt" value="">
        <input type="hidden" name="zap" :value="zap">
        <input type="hidden" name="thankyou" :value="thankYou">
        <input type="hidden" name="recaptchaToken" :value="recaptchaToken">
        <input type="hidden" name="description" :value="description">

        <input type="hidden" :value="keyword" name="keyword">
        <input type="hidden" :value="utm_campaign" name="utm_campaign">
        <input type="hidden" :value="utm_source" name="utm_source">
        <input type="hidden" :value="utm_medium" name="utm_medium">
        <input type="hidden" :value="utm_content" name="utm_content">
        <input type="hidden" :value="utm_term" name="utm_term">
        <input type="hidden" :value="utm_ts" name="utm_ts">
        <input type="hidden" :value="utm_ext_ad_id" name="utm_ext_ad_id">
        <input type="hidden" :value="utm_ext_adset_id" name="utm_ext_adset_id">
        <input type="hidden" :value="utm_ext_campaign_id" name="utm_ext_campaign_id">
        <input type="hidden" :value="fpv" name="fpv">
        <input type="hidden" :value="referrer" name="referrer">
        <input type="hidden" :value="ipAddress" name="ip_address">
        <input type="hidden" :value="ipData" name="ip_data">
        <input type="hidden" :value="quantcastID" name="quant_id">
        <input type="hidden" :value="mixpanelID" name="mixpanel_id">
        <input type="hidden" :value="segmentID" name="segment_id">
        <input type="hidden" :value="cid" name="cid">
        <input type="hidden" :value="experimentName" name="experimentName">
        <input type="hidden" :value="gclid" name="gclid">
        <input type="hidden" :value="_mkto_trk" name="_mkto_trk" id="_mkto_trk">
        <input type="hidden" :value="msclkid" name="msclkid">
        <input type="hidden" :value="phoneValid" name="phoneValid">
        <input type="hidden" :value="phoneType" name="phoneType">
        <input type="hidden" :value="emailValid" name="emailValid">
        <input type="hidden" :value="referralID" name="referralID">

    </fieldset>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    props: ['recaptchaToken'],
    computed: {
        ...mapGetters([
            'formFields'
        ]),
        ...mapState([
            'formTitle',
            'country',
            'writtenLanguage',
            'recaptchaToken',
            'keyword',
            'utm_campaign',
            'utm_source',
            'utm_medium',
            'utm_content',
            'utm_term',
            'utm_ts',
            'utm_ext_ad_id',
            'utm_ext_adset_id',
            'utm_ext_campaign_id',
            'fpv',
            'referrer',
            'ipAddress',
            'ipData',
            'quantcastID',
            'mixpanelID',
            'segmentID',
            'cid',
            'experimentName',
            'gclid',
            '_mkto_trk',
            'msclkid',
            'phoneValid',
            'phoneType',
            'emailValid',
            'zap',
            'thankYou',
            'referralID'
        ]),
        businessUnit() {
          if (this.$store.state.formFields['businessunit']) {
            return this.$store.state.formFields['businessunit'];
          }
          return ['Fleet'];
        },
        businessUnitTitle() {
          if (this.businessUnit.length !== 0) {
            return this.businessUnit.toString().toUpperCase().replace('SITES / BUILDINGS', 'CONNECTED SITES');
          } else {
            return 'FLEET';
          }
        },
        assetSize() {
          if (this.$store.state.formFields['assetcount']) {
            return this.$store.state.formFields['assetcount'];
          }
          return '';
        },
        companySize() {
          if (this.$store.state.formFields['companysize']) {
            return this.$store.state.formFields['companysize'];
          }
          return '';
        },
        industry() {
          if (this.$store.state.formFields['industry']) {
            return this.$store.state.formFields['industry'];
          }
          return '';
        },
        features() {
          if (this.$store.state.formFields['features']) {
            return this.$store.state.formFields['features'];
          }
          return '';
        },
        assets() {
          if (this.$store.state.formFields['assets']) {
            return this.$store.state.formFields['assets'];
          }
          return '';
        },
        description() {
          let description = `
                ** THIS IS A ${this.businessUnitTitle} PROSPECT **
                Business Unit: ${this.businessUnit}
                Form filled out: ${this.formTitle}
                Asset size: ${this.assetSize}
                Company Size: ${this.companySize}
                Industry: ${this.industry}
                Features: ${this.features}
                Assets: ${this.assets}
                Form URL: ${window.location.href}

          `;

          return description;
        }
    }
}
</script>
